  import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { CookieService } from 'ngx-cookie-service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as p from 'public-ip';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserDetails } from '../../../Autofacets-Core/src/app/business-entities/user-details';
import { CurrentLanguage } from '../../../Autofacets-Core/src/app/common-services/current-language.service';
import { SettingService } from './business-services/setting.service';
import { CustomerService } from './business-services/customer.service';
import { environment } from './../environments/environment'
import { CultureLocaleService } from './services/culture-locale.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  isIframe = false;
  title = 'Administration';
  redirectCount = 0;
  userDetails: UserDetails;
  userLoggedIn = false;
  globalizationValues:any;
  Version:any;
  status: boolean = false;
  currentYear: number
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private cultureLocaleService: CultureLocaleService,
    private settingService: SettingService,
    private secureStorage: SecureStorage,
    private msalService: MsalService,
    private broadcastService: MsalBroadcastService,
    private cookieService: CookieService,
    private userService: UserDataService,
    private currentLanguageService: CurrentLanguage,
    private router: Router,
    private service: CustomerService
  ) {
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.cookieService.delete('userSelectedLanguage');
    this.isIframe = window !== window.parent && !window.opener;
    this.msalService.handleRedirectObservable().subscribe();
    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe((_res) => {
        this.checkoutAccount();
        this.checkAndSetActiveAccount();
    })

    if (window.screen.width === 768) { // 768px portrait
      this.status = true;
    }
    this.getPostCodes();
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    let activeAccount = this.msalService.instance.getActiveAccount();

    if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
      let accounts = this.msalService.instance.getAllAccounts();
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  }
  checkoutAccount() {
    this.userLoggedIn = (this.msalService.instance.getAllAccounts().length > 0);
    this.currentLanguageService.userLoggedIn.next(this.userLoggedIn);
    if(localStorage.getItem(Constant.UserLoggedId)===null){
        p.publicIpv4().then((res)=>{
          if(res){
            let baseURL=environment.msalConfig.redirectUri.replace(/\/$/, "");
            let url=baseURL + this.router.url;
            this.userService.SetLoginActivity(true,res,url).then(
              _response => {
                 // This is intentional
              });
          }
        });
    }
    if(this.userLoggedIn){
      this.cultureLocaleService.initialise();
      this.settingService.getBrandList().then((res)=>{
        if(res?.responseObject?.length > 0){
          this.secureStorage.setKeyData("BrandList", res.responseObject);
        }else{
          console.info('Brands not found!')
        }
      })
    }
  }

  clickEvent() {
    this.status = !this.status;
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();

  }

  getPostCodes() {
    this.service.GetPostCodeDropdown().then((response) => {
      if (response?.responseObject?.length > 0) {
        this.secureStorage.setKeyData("postCodes", response.responseObject);
      } else {
        this.secureStorage.removeKey('postCodes');
        console.info('PostCodes not found!');
      }
    }, _error => {
      this.secureStorage.removeKey('postCodes');
    });
  }
}


